import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  Tooltip,
  Zoom,
  IconButton,
  Icon,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Auth } from 'aws-amplify';
import { ReactComponent as FlyttaLogo } from 'Images/flytta_logo.svg';

import { setUserSignedOut } from 'Actions/authUser';
import { APP_ROUTES } from 'Utils/appShell';

const styles = theme => ({
  centeredMenuIcon: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 96,
    minWidth: 96,
  },
  navMenuItem: {
    color: theme.palette.text.navigation,
  },
  navMenuItemSelected: {
    color: theme.palette.text.navigation,
    borderRightColor: theme.palette.selection.navigation,
    borderRightStyle: 'solid',
    borderRightWidth: 2,
  },
  navMenuItemDisabled: {
    opacity: 0.4,
  },
  navMenu: {
    backgroundColor: theme.palette.background.navigation,
  },
  iconButton: {
    transform: 'scale(1, 1)',
    transition: 'transform 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  clear: {
    color: '#f5a623',
    fontSize: '11px',
  },
  signOutButton: {
    marginTop: theme.spacing(4),
    color: 'white',
  },
});

class RailNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.state = {
      selectedNavIndex: props.initIndex,
    };
  }

  handleChange = changedIndex => {
    const { navItems, onNavChange } = this.props;
    this.setState(
      { selectedNavIndex: changedIndex },
      onNavChange(navItems[changedIndex].navRoute)
    );
  };

  async handleSignOut() {
    await Auth.signOut();
    const { setUserSignedOut, history } = this.props;
    setUserSignedOut();
    history.push(APP_ROUTES.AUTH_SIGNED_OUT);
  }

  render() {
    const { navItems, classes, currentUserRole } = this.props;
    const { selectedNavIndex } = this.state;

    return (
      <Drawer
        variant="permanent"
        open={false}
        classes={{ paper: classes.navMenu }}
      >
        <List>
          <ListItem disableGutters>
            <ListItemIcon classes={{ root: classes.centeredMenuIcon }}>
              <FlyttaLogo />
            </ListItemIcon>
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon classes={{ root: classes.centeredMenuIcon }}>
              <div />
            </ListItemIcon>
          </ListItem>
          {navItems.map((nav, index) =>
            nav.navEnabled &&
            (nav.restrictedToRole
              ? nav.restrictedToRole === currentUserRole
              : true) ? (
              <ListItem
                disableGutters
                button
                key={index}
                classes={{
                  root: classes.navMenuItem,
                  selected: classes.navMenuItemSelected,
                  disabled: classes.navMenuItemDisabled,
                }}
                selected={index === selectedNavIndex}
                onClick={() => this.handleChange(index)}
                disabled={!nav.navEnabled}
              >
                <Tooltip
                  TransitionComponent={Zoom}
                  title={nav.helpText}
                  placement="top"
                >
                  <ListItemIcon classes={{ root: classes.centeredMenuIcon }}>
                    {index === selectedNavIndex
                      ? nav.navIconActive
                      : nav.navIcon}
                  </ListItemIcon>
                </Tooltip>
              </ListItem>
            ) : null
          )}
          <ListItem classes={{ root: classes.centeredMenuIcon }}>
            <Tooltip
              TransitionComponent={Zoom}
              title="Click to Signout"
              placement="bottom"
            >
              <IconButton
                onClick={this.handleSignOut}
                className={classes.iconButton}
              >
                <Icon className={classes.signOutButton} large>
                  exit_to_app
                </Icon>
              </IconButton>
            </Tooltip>
          </ListItem>
        </List>
      </Drawer>
    );
  }
}

RailNavigation.propTypes = {
  classes: PropTypes.object,
  // FIXME: add correct prop validation for nav item object
  navItems: PropTypes.array,
  initIndex: PropTypes.number.isRequired,
  onNavChange: PropTypes.func.isRequired,
  setUserSignedOut: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  currentUserRole: PropTypes.string,
};

const mapStateToProps = state => ({
  currentUserRole: state.authUser.userProfile.role,
});

RailNavigation = compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(
    mapStateToProps,
    { setUserSignedOut }
  )
)(RailNavigation);

export default RailNavigation;
